export class DefaultForm {
	constructor(form) {
		this.$form = form;
		this.errors = [];
	}

	init() {
		$(this.$form).on("afterValidate", (event, messages, errorAttributes) => {
			this.errors = [];
			if (messages) {
				Object.keys(messages).forEach(key => {
					const keyLast = key.split("-")[1];
					if (messages.errors) {
						Object.keys(messages.errors).forEach(error => {
							if (error === keyLast) {
								this.errors.push(key);
							}
						});
					} else {
						if (messages[key].length) {
							this.errors.push(key);
						}
					}
				});
			}
			this.checkFields(this.$form);
		});
	}

	checkFields($form) {
		const $submitButton = $form.querySelector(".js-form-submit-button");
		const $fields = $form.querySelectorAll(".js-required-field");
		const $checkboxFields = $form.querySelectorAll(".js-form-checkbox");
		const isValid = this.checkInputs($fields) && this.checkCheckboxes($checkboxFields);
		isValid
			? this.activateSubmitButton($submitButton)
			: this.disableSubmitButton($submitButton);
	}

	disableSubmitButton($button) {
		$button.setAttribute("disabled", true);
	}

	activateSubmitButton($button) {
		$button.removeAttribute("disabled");
	}

	checkCheckboxes($checkboxes) {
		return Array.from($checkboxes).every($checkbox => {
			return this.checkCheckbox($checkbox);
		});
	}

	checkCheckbox($checkbox) {
		return $checkbox.checked;
	}

	checkInputs($inputs) {
		return Array.from($inputs).every($input => {
			return this.checkInput($input);
		});
	}

	checkInput($input) {
		const id = $input.getAttribute("id");
		let hasError = false;

		hasError = this.errors.some(error => {
			return error === id;
		});

		return Boolean($input.value.trim()) && !hasError;
	}
}
